<script>
  export let display = true;
  export let fullHeight = false;
  export let home = false;
</script>

{#if display}
  <div class='loading' class:loading-full-height={fullHeight} class:loading-home={home}>
    <div class='loading-box-1'/>
    <div class='loading-box-2'/>
    <div class='loading-box-3'/>
  </div>
{/if}

<style>
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    min-height: max(calc(30vh - 80px), 70px);

    z-index: 3;
  }

  .loading-full-height {
    height: max(calc(100vh - 60px), 70px);
  }

  .loading-home {
    min-height: max(calc(30vh - 160px), 70px);
  }

  .loading-box-1, .loading-box-2, .loading-box-3 {
    width: 15px;
    height: 45px;

    margin: 0px 5px;

    background: var(--grey-6);

    animation: loading 1s infinite;
  }

  .loading-box-2 {
    animation-delay: 0.25s;
  }

  .loading-box-3 {
    animation-delay: 0.50s;
  }

  @keyframes loading {
    20% {
      height: 67.5px;
    }
    40% {
      height: 45px;
    }
  }
</style>
